export enum BadgeType {
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  SUPER_ACTIVE = 'SUPER_ACTIVE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MASTER_CONTRIBUTOR = 'MASTER_CONTRIBUTOR',
  COMMENTATOR = 'COMMENTATOR',
  TOP_ENGAGER = 'TOP_ENGAGER',
  POSITIVE_VIBES = 'POSITIVE_VIBES',
  INSPIRING_AUTHOR = 'INSPIRING_AUTHOR',
  FRIENDLY = 'FRIENDLY',
  WELL_CONNECTED = 'WELL_CONNECTED',
  COMMUNITY_BUILDER = 'COMMUNITY_BUILDER',
  NEWBIE = 'NEWBIE',
  ONE_MONTH_MEMBER = 'ONE_MONTH_MEMBER',
  THREE_MONTH_LOYAL = 'THREE_MONTH_LOYAL',
  ONE_YEAR_VETERAN = 'ONE_YEAR_VETERAN',
  VERIFIED = 'VERIFIED',
  TRENDSETTER = 'TRENDSETTER',
  STAR_OF_THE_WEEK = 'STAR_OF_THE_WEEK',
  PEACEKEEPER = 'PEACEKEEPER',
  BUG_HUNTER = 'BUG_HUNTER'
}

export interface Badge {
  id: number;
  type: BadgeType;
  name: string;
  description?: string;
  iconUrl?: string;
  isAutoAssignable: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UserBadge {
  id: number;
  userId: number;
  badge: Badge;
  assignedBy?: number;
  assignedAt: string;
}

export interface CreateBadgeRequest {
  type: BadgeType;
  name: string;
  description?: string;
  iconUrl?: string;
  isAutoAssignable?: boolean;
}

export interface UpdateBadgeRequest {
  name?: string;
  description?: string;
  iconUrl?: string;
  isAutoAssignable?: boolean;
}

export interface AssignBadgeRequest {
  userId: number;
  badgeId: number;
}

export interface RemoveBadgeRequest {
  userId: number;
  badgeId: number;
}

export interface UserBadgesResponse {
  userId: number;
  badges: Badge[];
}

